import { render, staticRenderFns } from "./CategoryUsageTypeCustomField.vue?vue&type=template&id=5ca73ffe"
import script from "./CategoryUsageTypeCustomField.vue?vue&type=script&lang=js"
export * from "./CategoryUsageTypeCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports